import { useTranslation } from 'react-i18next';
import { Icon } from '@legacy/components/ui-components';
import LayoutSettings from '@legacy/components/layout/LayoutSettings';
import { usePageSettingsMenu } from '@legacy/apis/menusAPI/pageSettingsAPI';
import VerticalNavigationSearchBar from '@legacy/components/layout/VerticalNavigationSearchBar';
import { ReactNode } from 'react';

const icons = {
  DesignSevenFrontPage: <Icon iconName="setting" />,
  Customers: <Icon iconName="customer" />,
  Invoices: <Icon iconName="finance" />,
  Approval: <Icon iconName="like" />,
  Employees: <Icon iconName="employee" />,
  Projects: <Icon iconName="project" />,
  Reports: <Icon iconName="report" />,
  Register: <Icon iconName="timeAndExp" />,
  Create: <Icon iconName="circlePlus" />,
};

export const PageSettingsWrapper = ({ children }: { children: ReactNode }) => {
  const { pageSettingMenu, error, isLoading } = usePageSettingsMenu();
  const { t } = useTranslation('pageSettings');
  return (
    <LayoutSettings
      navigation={
        <VerticalNavigationSearchBar
          icons={icons}
          t={t}
          menu={pageSettingMenu}
          error={error}
          isLoading={isLoading}
        />
      }
      title={t('HeaderTitle')}
      isHelpVisible={false}
    >
      {children}
    </LayoutSettings>
  );
};
